import { variant } from 'styled-system';

const typeColors = [
  {
    type: 'positive',
    color: 'positive',
  },
  {
    type: 'informative',
    color: 'informative',
  },
  {
    type: 'warning',
    color: 'warning',
  },
  {
    type: 'negative',
    color: 'negative',
  },
  {
    type: 'persuasive',
    color: 'critical',
  },
  {
    type: 'neutral',
    color: 'neutrals',
  },
  {
    type: 'promotional',
    color: 'promotional.secondary',
  },
];

const semanticColorVariant = (colorToCss, colorVariants = ['default']) => {
  return variant({
    prop: 'type',
    variants: typeColors.reduce((variants, { type, color }) => {
      const colors = colorVariants.map((variant) => `${color}.${variant}`);
      variants[type] = colorToCss(...colors);
      return variants;
    }, {}),
  });
};

export const types = typeColors.map(({ type }) => type).concat('branded');

export default semanticColorVariant;
